













import { Component, Vue } from 'vue-property-decorator';
import AuthSwitcher from '@/components/auth-form/AuthSwitcher.vue';
import SignupForm from '@/components/auth-form/SignupForm.vue';
import AuthSwitcherMobile from '@/components/auth-form/AuthSwitcherMobile.vue';

@Component({
  name: 'SignUp',
  components: { AuthSwitcherMobile, AuthSwitcher, SignupForm }
})
export default class SignUp extends Vue {}
